"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactFontawesome = _interopRequireDefault(require("react-fontawesome"));
var _ThemeService = require("../common/ThemeService");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function PlayerLevel(props) {
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "mg-modal centre " + props.showModal
  }, /*#__PURE__*/_react["default"].createElement("div", {
    "data-e2e": "levelInfoData",
    className: "grade-info grid",
    style: {
      gridRowGap: '10px',
      gridTemplateColumns: 'auto',
      gridAutoRows: 'min-content'
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "level-info-header"
  }, /*#__PURE__*/_react["default"].createElement("h3", {
    style: {
      display: 'inline-block',
      margin: 0
    }
  }, "Level Information"), /*#__PURE__*/_react["default"].createElement("button", {
    onClick: props.closeLevelInfo,
    className: "btn btnHalo",
    "data-e2e": "closeLevelInfo",
    style: {
      padding: '0',
      height: '30px',
      width: '30px',
      "float": "right",
      backgroundColor: 'white'
    }
  }, /*#__PURE__*/_react["default"].createElement(_reactFontawesome["default"], {
    className: "centre",
    name: "fas fa-times",
    style: {
      fontSize: '25px',
      color: 'black'
    }
  }))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "share-level-body"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "skillLevelInfo",
    style: {
      display: 'grid',
      gridTemplateColumns: '1fr',
      gridRowGap: '10px'
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "grid levelAndExpHeadings",
    style: {
      display: 'grid',
      gridTemplateColumns: '1fr'
    }
  }, /*#__PURE__*/_react["default"].createElement("span", {
    style: {
      fontSize: '16px',
      fontWeight: 'bold',
      lineHeight: "22px",
      fontFamily: "Roboto"
    }
  }, "7 Skill Levels"), /*#__PURE__*/_react["default"].createElement("span", {
    style: {
      color: "#8B8B8B",
      fontStyle: "italic",
      fontSize: '14px',
      fontWeight: 'italic',
      lineHeight: "19px",
      fontFamily: "Roboto"
    }
  }, "The quality of your play during report")), props.medalsDetails.map(function (medal, i) {
    var medalName = medal.medal.replace(' ', '');
    return /*#__PURE__*/_react["default"].createElement("div", {
      key: i,
      className: "grid grade-info-medal-details"
    }, /*#__PURE__*/_react["default"].createElement("img", {
      className: "grade-info-medal",
      src: "//".concat(props.domain, "/images/Medals/").concat(_ThemeService.partyBrands.includes(props.brandLoggedInType) ? 'PartyPoker' + '/' + medal.gameType : medal.gameType, "/").concat(medalName, "/").concat(medalName, "_5.png")
    }), /*#__PURE__*/_react["default"].createElement("div", {
      style: {
        display: 'grid',
        gridTemplateColumns: 'auto',
        gridAutoRows: 'min-content'
      }
    }, /*#__PURE__*/_react["default"].createElement("b", null, medalName), /*#__PURE__*/_react["default"].createElement("p", {
      style: {
        color: "#8B8B8B",
        fontStyle: "italic",
        fontSize: '14px',
        fontWeight: 'italic',
        lineHeight: "19px",
        fontFamily: "Roboto"
      }
    }, "".concat(medal.min_range, "% to ").concat(medal.max_range, "% overall score"))));
  })), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "skillLevelInfo",
    style: {
      display: 'grid',
      gridTemplateColumns: '1fr',
      gridRowGap: '10px'
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "grid",
    style: {
      display: 'grid',
      gridTemplateColumns: '1fr'
    }
  }, /*#__PURE__*/_react["default"].createElement("span", {
    style: {
      fontSize: '16px',
      fontWeight: 'bold',
      lineHeight: "22px",
      fontFamily: "Roboto"
    }
  }, "Experience Diamonds"), /*#__PURE__*/_react["default"].createElement("span", {
    className: "player-level-exp-stars"
  }, "The number of hands played during the report")), /*#__PURE__*/_react["default"].createElement("div", {
    className: "grade-info-expInfo"
  }, props.starListElem.map(function (elem) {
    return elem;
  })))))));
}
var _default = PlayerLevel;
exports["default"] = _default;


/*****************
 ** WEBPACK FOOTER
 ** ./~/mygame-components/dist/ReportCards/PlayerLevel.js
 ** module id = 657
 ** module chunks = 0
 **/